// src/config.js
export const equipments =[
  {
      "name": "等离子裁决盔甲-头盔-常见",
      "identifier": "plasma_judgment_armor_helmet_0",
      "max_damage": 338.8852459,
      "defense": 1,
      "enchantment": 9,
      "toughness": 1,
      "knockback_resistance": 0.01
  },
  {
      "name": "等离子裁决盔甲-头盔-精英",
      "identifier": "plasma_judgment_armor_helmet_1",
      "max_damage": 677.7704918,
      "defense": 2,
      "enchantment": 10,
      "toughness": 2,
      "knockback_resistance": 0.02
  },
  {
      "name": "等离子裁决盔甲-头盔-优质",
      "identifier": "plasma_judgment_armor_helmet_2",
      "max_damage": 1355.540984,
      "defense": 2,
      "enchantment": 15,
      "toughness": 2,
      "knockback_resistance": 0.04
  },
  {
      "name": "等离子裁决盔甲-头盔-罕见",
      "identifier": "plasma_judgment_armor_helmet_3",
      "max_damage": 5424.393443,
      "defense": 3,
      "enchantment": 18,
      "toughness": 2,
      "knockback_resistance": 0.06
  },
  {
      "name": "等离子裁决盔甲-头盔-大师",
      "identifier": "plasma_judgment_armor_helmet_4",
      "max_damage": 10848.78689,
      "defense": 3,
      "enchantment": 22,
      "toughness": 3,
      "knockback_resistance": 0.08
  },
  {
      "name": "等离子裁决盔甲-头盔-传奇",
      "identifier": "plasma_judgment_armor_helmet_5",
      "max_damage": 21697.57377,
      "defense": 3,
      "enchantment": 25,
      "toughness": 4,
      "knockback_resistance": 0.1
  },
  {
      "name": "等离子裁决盔甲-胸甲-常见",
      "identifier": "plasma_judgment_armor_breastplate_0",
      "max_damage": 304,
      "defense": 8,
      "enchantment": 9,
      "toughness": 4,
      "knockback_resistance": 0.09
  },
  {
      "name": "等离子裁决盔甲-胸甲-精英",
      "identifier": "plasma_judgment_armor_breastplate_1",
      "max_damage": 608,
      "defense": 8,
      "enchantment": 10,
      "toughness": 4,
      "knockback_resistance": 0.11
  },
  {
      "name": "等离子裁决盔甲-胸甲-优质",
      "identifier": "plasma_judgment_armor_breastplate_2",
      "max_damage": 1216,
      "defense": 8,
      "enchantment": 15,
      "toughness": 4,
      "knockback_resistance": 0.13
  },
  {
      "name": "等离子裁决盔甲-胸甲-罕见",
      "identifier": "plasma_judgment_armor_breastplate_3",
      "max_damage": 4866,
      "defense": 8,
      "enchantment": 18,
      "toughness": 5,
      "knockback_resistance": 0.15
  },
  {
      "name": "等离子裁决盔甲-胸甲-大师",
      "identifier": "plasma_judgment_armor_breastplate_4",
      "max_damage": 9732,
      "defense": 8,
      "enchantment": 22,
      "toughness": 5,
      "knockback_resistance": 0.17
  },
  {
      "name": "等离子裁决盔甲-胸甲-传奇",
      "identifier": "plasma_judgment_armor_breastplate_5",
      "max_damage": 19464,
      "defense": 8,
      "enchantment": 25,
      "toughness": 5,
      "knockback_resistance": 0.2
  },
  {
      "name": "等离子裁决盔甲-护腿-常见",
      "identifier": "plasma_judgment_armor_leggings_0",
      "max_damage": 328.9180328,
      "defense": 6,
      "enchantment": 9,
      "toughness": 3,
      "knockback_resistance": 0.09
  },
  {
      "name": "等离子裁决盔甲-护腿-精英",
      "identifier": "plasma_judgment_armor_leggings_1",
      "max_damage": 657.8360656,
      "defense": 6,
      "enchantment": 10,
      "toughness": 3,
      "knockback_resistance": 0.11
  },
  {
      "name": "等离子裁决盔甲-护腿-优质",
      "identifier": "plasma_judgment_armor_leggings_2",
      "max_damage": 1315.672131,
      "defense": 6,
      "enchantment": 15,
      "toughness": 4,
      "knockback_resistance": 0.13
  },
  {
      "name": "等离子裁决盔甲-护腿-罕见",
      "identifier": "plasma_judgment_armor_leggings_3",
      "max_damage": 5264.852459,
      "defense": 6,
      "enchantment": 18,
      "toughness": 4,
      "knockback_resistance": 0.15
  },
  {
      "name": "等离子裁决盔甲-护腿-大师",
      "identifier": "plasma_judgment_armor_leggings_4",
      "max_damage": 10529.70492,
      "defense": 6,
      "enchantment": 22,
      "toughness": 4,
      "knockback_resistance": 0.17
  },
  {
      "name": "等离子裁决盔甲-护腿-传奇",
      "identifier": "plasma_judgment_armor_leggings_5",
      "max_damage": 21059.40984,
      "defense": 6,
      "enchantment": 25,
      "toughness": 5,
      "knockback_resistance": 0.2
  },
  {
      "name": "等离子裁决盔甲-靴子-常见",
      "identifier": "plasma_judgment_armor_boots_0",
      "max_damage": 498.3606557,
      "defense": 1,
      "enchantment": 9,
      "toughness": 1,
      "knockback_resistance": 0.01
  },
  {
      "name": "等离子裁决盔甲-靴子-精英",
      "identifier": "plasma_judgment_armor_boots_1",
      "max_damage": 996.7213115,
      "defense": 2,
      "enchantment": 10,
      "toughness": 2,
      "knockback_resistance": 0.02
  },
  {
      "name": "等离子裁决盔甲-靴子-优质",
      "identifier": "plasma_judgment_armor_boots_2",
      "max_damage": 1993.442623,
      "defense": 2,
      "enchantment": 15,
      "toughness": 2,
      "knockback_resistance": 0.04
  },
  {
      "name": "等离子裁决盔甲-靴子-罕见",
      "identifier": "plasma_judgment_armor_boots_3",
      "max_damage": 7977.04918,
      "defense": 3,
      "enchantment": 18,
      "toughness": 3,
      "knockback_resistance": 0.06
  },
  {
      "name": "等离子裁决盔甲-靴子-大师",
      "identifier": "plasma_judgment_armor_boots_4",
      "max_damage": 15954.09836,
      "defense": 3,
      "enchantment": 22,
      "toughness": 3,
      "knockback_resistance": 0.08
  },
  {
      "name": "等离子裁决盔甲-靴子-传奇",
      "identifier": "plasma_judgment_armor_boots_5",
      "max_damage": 31908.19672,
      "defense": 3,
      "enchantment": 25,
      "toughness": 4,
      "knockback_resistance": 0.1
  },
  {
      "name": "双难守护盔甲-头盔-常见",
      "identifier": "double_dilemma_guard_helmet_0",
      "max_damage": 392.3934426,
      "defense": 2,
      "enchantment": 9,
      "toughness": 0,
      "knockback_resistance": 0
  },
  {
      "name": "双难守护盔甲-头盔-精英",
      "identifier": "double_dilemma_guard_helmet_1",
      "max_damage": 535.0819672,
      "defense": 2,
      "enchantment": 10,
      "toughness": 0,
      "knockback_resistance": 0.01
  },
  {
      "name": "双难守护盔甲-头盔-优质",
      "identifier": "double_dilemma_guard_helmet_2",
      "max_damage": 677.7704918,
      "defense": 2,
      "enchantment": 15,
      "toughness": 1,
      "knockback_resistance": 0.01
  },
  {
      "name": "双难守护盔甲-头盔-罕见",
      "identifier": "double_dilemma_guard_helmet_3",
      "max_damage": 1355.540984,
      "defense": 2,
      "enchantment": 18,
      "toughness": 1,
      "knockback_resistance": 0.03
  },
  {
      "name": "双难守护盔甲-头盔-大师",
      "identifier": "double_dilemma_guard_helmet_4",
      "max_damage": 5424.393443,
      "defense": 3,
      "enchantment": 22,
      "toughness": 1,
      "knockback_resistance": 0.03
  },
  {
      "name": "双难守护盔甲-头盔-传奇",
      "identifier": "double_dilemma_guard_helmet_5",
      "max_damage": 10848.78689,
      "defense": 3,
      "enchantment": 25,
      "toughness": 2,
      "knockback_resistance": 0.05
  },
  {
      "name": "双难守护盔甲-胸甲-常见",
      "identifier": "double_dilemma_guard_breastplate_0",
      "max_damage": 352,
      "defense": 5,
      "enchantment": 9,
      "toughness": 0,
      "knockback_resistance": 0
  },
  {
      "name": "双难守护盔甲-胸甲-精英",
      "identifier": "double_dilemma_guard_breastplate_1",
      "max_damage": 480,
      "defense": 5,
      "enchantment": 10,
      "toughness": 1,
      "knockback_resistance": 0.01
  },
  {
      "name": "双难守护盔甲-胸甲-优质",
      "identifier": "double_dilemma_guard_breastplate_2",
      "max_damage": 608,
      "defense": 5,
      "enchantment": 15,
      "toughness": 1,
      "knockback_resistance": 0.01
  },
  {
      "name": "双难守护盔甲-胸甲-罕见",
      "identifier": "double_dilemma_guard_breastplate_3",
      "max_damage": 1216,
      "defense": 6,
      "enchantment": 18,
      "toughness": 2,
      "knockback_resistance": 0.03
  },
  {
      "name": "双难守护盔甲-胸甲-大师",
      "identifier": "double_dilemma_guard_breastplate_4",
      "max_damage": 4866,
      "defense": 6,
      "enchantment": 22,
      "toughness": 2,
      "knockback_resistance": 0.03
  },
  {
      "name": "双难守护盔甲-胸甲-传奇",
      "identifier": "double_dilemma_guard_breastplate_5",
      "max_damage": 9732,
      "defense": 7,
      "enchantment": 25,
      "toughness": 3,
      "knockback_resistance": 0.05
  },
  {
      "name": "双难守护盔甲-护腿-常见",
      "identifier": "double_dilemma_guard_leggings_0",
      "max_damage": 380.852459,
      "defense": 3,
      "enchantment": 9,
      "toughness": 0,
      "knockback_resistance": 0
  },
  {
      "name": "双难守护盔甲-护腿-精英",
      "identifier": "double_dilemma_guard_leggings_1",
      "max_damage": 519.3442623,
      "defense": 3,
      "enchantment": 10,
      "toughness": 1,
      "knockback_resistance": 0.01
  },
  {
      "name": "双难守护盔甲-护腿-优质",
      "identifier": "double_dilemma_guard_leggings_2",
      "max_damage": 657.8360656,
      "defense": 3,
      "enchantment": 15,
      "toughness": 1,
      "knockback_resistance": 0.01
  },
  {
      "name": "双难守护盔甲-护腿-罕见",
      "identifier": "double_dilemma_guard_leggings_3",
      "max_damage": 1315.672131,
      "defense": 4,
      "enchantment": 18,
      "toughness": 2,
      "knockback_resistance": 0.03
  },
  {
      "name": "双难守护盔甲-护腿-大师",
      "identifier": "double_dilemma_guard_leggings_4",
      "max_damage": 5264.852459,
      "defense": 4,
      "enchantment": 22,
      "toughness": 2,
      "knockback_resistance": 0.03
  },
  {
      "name": "双难守护盔甲-护腿-传奇",
      "identifier": "double_dilemma_guard_leggings_5",
      "max_damage": 10529.70492,
      "defense": 5,
      "enchantment": 25,
      "toughness": 3,
      "knockback_resistance": 0.05
  },
  {
      "name": "双难守护盔甲-靴子-常见",
      "identifier": "double_dilemma_guard_boots_0",
      "max_damage": 577.0491803,
      "defense": 2,
      "enchantment": 9,
      "toughness": 0,
      "knockback_resistance": 0
  },
  {
      "name": "双难守护盔甲-靴子-精英",
      "identifier": "double_dilemma_guard_boots_1",
      "max_damage": 786.8852459,
      "defense": 2,
      "enchantment": 10,
      "toughness": 0,
      "knockback_resistance": 0.01
  },
  {
      "name": "双难守护盔甲-靴子-优质",
      "identifier": "double_dilemma_guard_boots_2",
      "max_damage": 996.7213115,
      "defense": 2,
      "enchantment": 15,
      "toughness": 1,
      "knockback_resistance": 0.01
  },
  {
      "name": "双难守护盔甲-靴子-罕见",
      "identifier": "double_dilemma_guard_boots_3",
      "max_damage": 1993.442623,
      "defense": 2,
      "enchantment": 18,
      "toughness": 1,
      "knockback_resistance": 0.03
  },
  {
      "name": "双难守护盔甲-靴子-大师",
      "identifier": "double_dilemma_guard_boots_4",
      "max_damage": 7977.04918,
      "defense": 3,
      "enchantment": 22,
      "toughness": 1,
      "knockback_resistance": 0.03
  },
  {
      "name": "双难守护盔甲-靴子-传奇",
      "identifier": "double_dilemma_guard_boots_5",
      "max_damage": 15954.09836,
      "defense": 3,
      "enchantment": 25,
      "toughness": 2,
      "knockback_resistance": 0.05
  },
  {
      "name": "葛伦科铁之盾盔甲-头盔-常见",
      "identifier": "glencoe_iron_shield_helmet_0",
      "max_damage": 535.0819672,
      "defense": 1,
      "enchantment": 11,
      "toughness": 1,
      "knockback_resistance": 0.05
  },
  {
      "name": "葛伦科铁之盾盔甲-头盔-精英",
      "identifier": "glencoe_iron_shield_helmet_1",
      "max_damage": 820.4590164,
      "defense": 2,
      "enchantment": 11,
      "toughness": 1,
      "knockback_resistance": 0.07
  },
  {
      "name": "葛伦科铁之盾盔甲-头盔-优质",
      "identifier": "glencoe_iron_shield_helmet_2",
      "max_damage": 1070.163934,
      "defense": 2,
      "enchantment": 12,
      "toughness": 2,
      "knockback_resistance": 0.09
  },
  {
      "name": "葛伦科铁之盾盔甲-头盔-罕见",
      "identifier": "glencoe_iron_shield_helmet_3",
      "max_damage": 2141.442623,
      "defense": 3,
      "enchantment": 13,
      "toughness": 2,
      "knockback_resistance": 0.11
  },
  {
      "name": "葛伦科铁之盾盔甲-头盔-大师",
      "identifier": "glencoe_iron_shield_helmet_4",
      "max_damage": 8565.770492,
      "defense": 3,
      "enchantment": 14,
      "toughness": 2,
      "knockback_resistance": 0.13
  },
  {
      "name": "葛伦科铁之盾盔甲-头盔-传奇",
      "identifier": "glencoe_iron_shield_helmet_5",
      "max_damage": 17131.54098,
      "defense": 3,
      "enchantment": 15,
      "toughness": 3,
      "knockback_resistance": 0.15
  },
  {
      "name": "葛伦科铁之盾盔甲-胸甲-常见",
      "identifier": "glencoe_iron_shield_breastplate_0",
      "max_damage": 480,
      "defense": 8,
      "enchantment": 11,
      "toughness": 3,
      "knockback_resistance": 0.1
  },
  {
      "name": "葛伦科铁之盾盔甲-胸甲-精英",
      "identifier": "glencoe_iron_shield_breastplate_1",
      "max_damage": 736,
      "defense": 8,
      "enchantment": 11,
      "toughness": 4,
      "knockback_resistance": 0.12
  },
  {
      "name": "葛伦科铁之盾盔甲-胸甲-优质",
      "identifier": "glencoe_iron_shield_breastplate_2",
      "max_damage": 960,
      "defense": 8,
      "enchantment": 12,
      "toughness": 4,
      "knockback_resistance": 0.14
  },
  {
      "name": "葛伦科铁之盾盔甲-胸甲-罕见",
      "identifier": "glencoe_iron_shield_breastplate_3",
      "max_damage": 1921,
      "defense": 8,
      "enchantment": 13,
      "toughness": 4,
      "knockback_resistance": 0.16
  },
  {
      "name": "葛伦科铁之盾盔甲-胸甲-大师",
      "identifier": "glencoe_iron_shield_breastplate_4",
      "max_damage": 7684,
      "defense": 8,
      "enchantment": 14,
      "toughness": 5,
      "knockback_resistance": 0.18
  },
  {
      "name": "葛伦科铁之盾盔甲-胸甲-传奇",
      "identifier": "glencoe_iron_shield_breastplate_5",
      "max_damage": 15368,
      "defense": 8,
      "enchantment": 15,
      "toughness": 5,
      "knockback_resistance": 0.2
  },
  {
      "name": "葛伦科铁之盾盔甲-护腿-常见",
      "identifier": "glencoe_iron_shield_leggings_0",
      "max_damage": 519.3442623,
      "defense": 6,
      "enchantment": 11,
      "toughness": 3,
      "knockback_resistance": 0.1
  },
  {
      "name": "葛伦科铁之盾盔甲-护腿-精英",
      "identifier": "glencoe_iron_shield_leggings_1",
      "max_damage": 796.3278689,
      "defense": 6,
      "enchantment": 11,
      "toughness": 4,
      "knockback_resistance": 0.12
  },
  {
      "name": "葛伦科铁之盾盔甲-护腿-优质",
      "identifier": "glencoe_iron_shield_leggings_2",
      "max_damage": 1038.688525,
      "defense": 6,
      "enchantment": 12,
      "toughness": 4,
      "knockback_resistance": 0.14
  },
  {
      "name": "葛伦科铁之盾盔甲-护腿-罕见",
      "identifier": "glencoe_iron_shield_leggings_3",
      "max_damage": 2078.459016,
      "defense": 6,
      "enchantment": 13,
      "toughness": 4,
      "knockback_resistance": 0.16
  },
  {
      "name": "葛伦科铁之盾盔甲-护腿-大师",
      "identifier": "glencoe_iron_shield_leggings_4",
      "max_damage": 8313.836066,
      "defense": 6,
      "enchantment": 14,
      "toughness": 5,
      "knockback_resistance": 0.18
  },
  {
      "name": "葛伦科铁之盾盔甲-护腿-传奇",
      "identifier": "glencoe_iron_shield_leggings_5",
      "max_damage": 16627.67213,
      "defense": 6,
      "enchantment": 15,
      "toughness": 5,
      "knockback_resistance": 0.2
  },
  {
      "name": "葛伦科铁之盾盔甲-靴子-常见",
      "identifier": "glencoe_iron_shield_boots_0",
      "max_damage": 786.8852459,
      "defense": 1,
      "enchantment": 11,
      "toughness": 1,
      "knockback_resistance": 0.05
  },
  {
      "name": "葛伦科铁之盾盔甲-靴子-精英",
      "identifier": "glencoe_iron_shield_boots_1",
      "max_damage": 1206.557377,
      "defense": 2,
      "enchantment": 11,
      "toughness": 1,
      "knockback_resistance": 0.07
  },
  {
      "name": "葛伦科铁之盾盔甲-靴子-优质",
      "identifier": "glencoe_iron_shield_boots_2",
      "max_damage": 1573.770492,
      "defense": 2,
      "enchantment": 12,
      "toughness": 1,
      "knockback_resistance": 0.09
  },
  {
      "name": "葛伦科铁之盾盔甲-靴子-罕见",
      "identifier": "glencoe_iron_shield_boots_3",
      "max_damage": 3149.180328,
      "defense": 3,
      "enchantment": 13,
      "toughness": 2,
      "knockback_resistance": 0.11
  },
  {
      "name": "葛伦科铁之盾盔甲-靴子-大师",
      "identifier": "glencoe_iron_shield_boots_4",
      "max_damage": 12596.72131,
      "defense": 3,
      "enchantment": 14,
      "toughness": 2,
      "knockback_resistance": 0.13
  },
  {
      "name": "葛伦科铁之盾盔甲-靴子-传奇",
      "identifier": "glencoe_iron_shield_boots_5",
      "max_damage": 25193.44262,
      "defense": 3,
      "enchantment": 15,
      "toughness": 3,
      "knockback_resistance": 0.15
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-头盔-常见",
      "identifier": "heavy_glencoe_iron_fortress_helmet_0",
      "max_damage": 338.8852459,
      "defense": 1,
      "enchantment": 9,
      "toughness": 2,
      "knockback_resistance": 0.1
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-头盔-精英",
      "identifier": "heavy_glencoe_iron_fortress_helmet_1",
      "max_damage": 677.7704918,
      "defense": 2,
      "enchantment": 10,
      "toughness": 2,
      "knockback_resistance": 0.12
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-头盔-优质",
      "identifier": "heavy_glencoe_iron_fortress_helmet_2",
      "max_damage": 1355.540984,
      "defense": 2,
      "enchantment": 10,
      "toughness": 3,
      "knockback_resistance": 0.14
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-头盔-罕见",
      "identifier": "heavy_glencoe_iron_fortress_helmet_3",
      "max_damage": 5424.393443,
      "defense": 3,
      "enchantment": 11,
      "toughness": 3,
      "knockback_resistance": 0.16
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-头盔-大师",
      "identifier": "heavy_glencoe_iron_fortress_helmet_4",
      "max_damage": 10848.78689,
      "defense": 3,
      "enchantment": 11,
      "toughness": 3,
      "knockback_resistance": 0.18
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-头盔-传奇",
      "identifier": "heavy_glencoe_iron_fortress_helmet_5",
      "max_damage": 21697.57377,
      "defense": 3,
      "enchantment": 12,
      "toughness": 4,
      "knockback_resistance": 0.2
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-胸甲-常见",
      "identifier": "heavy_glencoe_iron_fortress_breastplate_0",
      "max_damage": 304,
      "defense": 8,
      "enchantment": 9,
      "toughness": 4,
      "knockback_resistance": 0.15
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-胸甲-精英",
      "identifier": "heavy_glencoe_iron_fortress_breastplate_1",
      "max_damage": 608,
      "defense": 8,
      "enchantment": 10,
      "toughness": 4,
      "knockback_resistance": 0.17
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-胸甲-优质",
      "identifier": "heavy_glencoe_iron_fortress_breastplate_2",
      "max_damage": 1216,
      "defense": 8,
      "enchantment": 10,
      "toughness": 5,
      "knockback_resistance": 0.19
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-胸甲-罕见",
      "identifier": "heavy_glencoe_iron_fortress_breastplate_3",
      "max_damage": 4866,
      "defense": 8,
      "enchantment": 11,
      "toughness": 5,
      "knockback_resistance": 0.21
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-胸甲-大师",
      "identifier": "heavy_glencoe_iron_fortress_breastplate_4",
      "max_damage": 9732,
      "defense": 8,
      "enchantment": 11,
      "toughness": 6,
      "knockback_resistance": 0.23
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-胸甲-传奇",
      "identifier": "heavy_glencoe_iron_fortress_breastplate_5",
      "max_damage": 19464,
      "defense": 8,
      "enchantment": 12,
      "toughness": 6,
      "knockback_resistance": 0.25
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-护腿-常见",
      "identifier": "heavy_glencoe_iron_fortress_leggings_0",
      "max_damage": 328.9180328,
      "defense": 6,
      "enchantment": 9,
      "toughness": 4,
      "knockback_resistance": 0.15
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-护腿-精英",
      "identifier": "heavy_glencoe_iron_fortress_leggings_1",
      "max_damage": 657.8360656,
      "defense": 6,
      "enchantment": 10,
      "toughness": 4,
      "knockback_resistance": 0.17
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-护腿-优质",
      "identifier": "heavy_glencoe_iron_fortress_leggings_2",
      "max_damage": 1315.672131,
      "defense": 6,
      "enchantment": 10,
      "toughness": 4,
      "knockback_resistance": 0.19
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-护腿-罕见",
      "identifier": "heavy_glencoe_iron_fortress_leggings_3",
      "max_damage": 5264.852459,
      "defense": 6,
      "enchantment": 11,
      "toughness": 5,
      "knockback_resistance": 0.21
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-护腿-大师",
      "identifier": "heavy_glencoe_iron_fortress_leggings_4",
      "max_damage": 10529.70492,
      "defense": 6,
      "enchantment": 11,
      "toughness": 6,
      "knockback_resistance": 0.23
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-护腿-传奇",
      "identifier": "heavy_glencoe_iron_fortress_leggings_5",
      "max_damage": 21059.40984,
      "defense": 6,
      "enchantment": 12,
      "toughness": 6,
      "knockback_resistance": 0.25
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-靴子-常见",
      "identifier": "heavy_glencoe_iron_fortress_boots_0",
      "max_damage": 498.3606557,
      "defense": 1,
      "enchantment": 9,
      "toughness": 2,
      "knockback_resistance": 0.1
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-靴子-精英",
      "identifier": "heavy_glencoe_iron_fortress_boots_1",
      "max_damage": 996.7213115,
      "defense": 2,
      "enchantment": 10,
      "toughness": 2,
      "knockback_resistance": 0.12
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-靴子-优质",
      "identifier": "heavy_glencoe_iron_fortress_boots_2",
      "max_damage": 1993.442623,
      "defense": 2,
      "enchantment": 10,
      "toughness": 3,
      "knockback_resistance": 0.14
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-靴子-罕见",
      "identifier": "heavy_glencoe_iron_fortress_boots_3",
      "max_damage": 7977.04918,
      "defense": 3,
      "enchantment": 11,
      "toughness": 3,
      "knockback_resistance": 0.16
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-靴子-大师",
      "identifier": "heavy_glencoe_iron_fortress_boots_4",
      "max_damage": 15954.09836,
      "defense": 3,
      "enchantment": 11,
      "toughness": 3,
      "knockback_resistance": 0.18
  },
  {
      "name": "重型葛伦科铁堡垒盔甲-靴子-传奇",
      "identifier": "heavy_glencoe_iron_fortress_boots_5",
      "max_damage": 31908.19672,
      "defense": 3,
      "enchantment": 12,
      "toughness": 4,
      "knockback_resistance": 0.2
  },
  {
      "name": "暗影行者头盔-常见",
      "identifier": "shadowwalker_helmet_0",
      "max_damage": 225,
      "defense": 1,
      "enchantment": 9,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "暗影行者头盔-精英",
      "identifier": "shadowwalker_helmet_1",
      "max_damage": 375,
      "defense": 1,
      "enchantment": 10,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "暗影行者头盔-优质",
      "identifier": "shadowwalker_helmet_2",
      "max_damage": 425,
      "defense": 2,
      "enchantment": 15,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "暗影行者头盔-罕见",
      "identifier": "shadowwalker_helmet_3",
      "max_damage": 495,
      "defense": 2,
      "enchantment": 18,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "暗影行者头盔-大师",
      "identifier": "shadowwalker_helmet_4",
      "max_damage": 555,
      "defense": 2,
      "enchantment": 22,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "暗影行者头盔-传奇",
      "identifier": "shadowwalker_helmet_5",
      "max_damage": 888,
      "defense": 2,
      "enchantment": 25,
      "toughness": 2,
      "knockback_resistance": 0
  },
  {
      "name": "风之轻语战靴-常见",
      "identifier": "whisper_of_the_wind_boots_0",
      "max_damage": 225,
      "defense": 1,
      "enchantment": 9,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "风之轻语战靴-精英",
      "identifier": "whisper_of_the_wind_boots_1",
      "max_damage": 375,
      "defense": 1,
      "enchantment": 10,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "风之轻语战靴-优质",
      "identifier": "whisper_of_the_wind_boots_2",
      "max_damage": 425,
      "defense": 2,
      "enchantment": 15,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "风之轻语战靴-罕见",
      "identifier": "whisper_of_the_wind_boots_3",
      "max_damage": 495,
      "defense": 2,
      "enchantment": 18,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "风之轻语战靴-大师",
      "identifier": "whisper_of_the_wind_boots_4",
      "max_damage": 555,
      "defense": 2,
      "enchantment": 22,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "风之轻语战靴-传奇",
      "identifier": "whisper_of_the_wind_boots_5",
      "max_damage": 888,
      "defense": 2,
      "enchantment": 25,
      "toughness": 2,
      "knockback_resistance": 0
  },
  {
      "name": "风行者斗篷-常见",
      "identifier": "windrunner_cape_0",
      "max_damage": 225,
      "defense": 1,
      "enchantment": 9,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "风行者斗篷-精英",
      "identifier": "windrunner_cape_1",
      "max_damage": 375,
      "defense": 1,
      "enchantment": 10,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "风行者斗篷-优质",
      "identifier": "windrunner_cape_2",
      "max_damage": 425,
      "defense": 2,
      "enchantment": 15,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "风行者斗篷-罕见",
      "identifier": "windrunner_cape_3",
      "max_damage": 495,
      "defense": 2,
      "enchantment": 18,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "风行者斗篷-大师",
      "identifier": "windrunner_cape_4",
      "max_damage": 555,
      "defense": 2,
      "enchantment": 22,
      "toughness": 1,
      "knockback_resistance": 0
  },
  {
      "name": "风行者斗篷-传奇",
      "identifier": "windrunner_cape_5",
      "max_damage": 888,
      "defense": 2,
      "enchantment": 25,
      "toughness": 2,
      "knockback_resistance": 0
  }
];
